import { render } from "./InfoItemList.vue?vue&type=template&id=04bbaedf&ts=true"
import script from "./InfoItemList.vue?vue&type=script&lang=ts"
export * from "./InfoItemList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__